<template>
  <div class="bg-white shadow-sm border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-3xl font-bold text-gray-900">Счета</h1>
          <p class="mt-1 text-sm text-gray-500">Управление счетами</p>
        </div>
        <button
          @click="openCreateModal"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        >
          <i class="pi pi-plus mr-2"></i>
          Создать счет
        </button>
      </div>
    </div>
  </div>
  <div class="container mx-auto px-4 py-8">
    <div class="bg-white shadow-md rounded-lg overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <button
              @click="showFilters = !showFilters"
              class="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 transition-colors duration-150"
            >
              <i
                class="pi transition-transform duration-200"
                :class="showFilters ? 'pi-chevron-up' : 'pi-chevron-down'"
              ></i>
              <span>Фильтры</span>
              <span
                v-if="activeFiltersCount > 0"
                class="inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-blue-600 rounded-full"
              >
                {{ activeFiltersCount }}
              </span>
            </button>
            <div class="flex items-center space-x-2">
              <label class="text-sm font-medium text-gray-700"
                >Сортировка:</label
              >
              <select
                v-model="filters.sort"
                @change="
                  () => {
                    updateURL()
                    loadInvoices()
                  }
                "
                class="px-3 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="payment_period">По дате</option>
                <option value="number_of_invoice">По номеру</option>
                <option value="id">По ID</option>
                <option value="sum_amount">По сумме</option>
                <option value="legal_name">По юр. лицу</option>
                <option value="payment_account_name">
                  По платежному аккаунту
                </option>
              </select>
              <button
                @click="
                  () => {
                    filters.order = filters.order === 'asc' ? 'desc' : 'asc'
                    updateURL()
                    loadInvoices()
                  }
                "
                class="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-150"
                :title="
                  filters.order === 'asc' ? 'По возрастанию' : 'По убыванию'
                "
              >
                <i
                  class="pi text-lg transition-all duration-200"
                  :class="
                    filters.order === 'asc' ? 'pi-arrow-up' : 'pi-arrow-down'
                  "
                ></i>
              </button>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <button
              @click="resetFilters"
              class="px-3 py-2 text-sm text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 transition-colors duration-150"
            >
              <i class="pi pi-refresh mr-2"></i>
              Сбросить
            </button>
            <button
              v-if="selectedInvoices.length > 0"
              @click="copySelectedInvoices"
              class="px-3 py-2 text-sm text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 transition-colors duration-150"
            >
              <i class="pi pi-copy mr-2"></i>
              Копировать счета ({{ selectedInvoices.length }})
            </button>
          </div>
        </div>
      </div>

      <div
        v-show="showFilters"
        class="px-6 py-4 border-b border-gray-200 bg-white"
      >
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Номер счета</label
            >
            <input
              v-model="filters.number_of_invoice"
              @input="debouncedSearch"
              type="text"
              placeholder="Введите номер счета..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >ID счета</label
            >
            <input
              v-model="filters.id"
              @input="debouncedSearch"
              type="number"
              placeholder="Введите ID..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Номер договора</label
            >
            <input
              v-model="filters.number_of_contract"
              @input="debouncedSearch"
              type="text"
              placeholder="Введите номер договора..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >ID договора</label
            >
            <input
              v-model="filters.contract_id"
              @input="debouncedSearch"
              type="number"
              placeholder="Введите ID договора..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Дата счета</label
            >
            <input
              v-model="filters.date_of_invoice"
              @input="debouncedSearch"
              type="date"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Статус</label
            >
            <select
              v-model="filters.draft"
              @change="
                () => {
                  updateURL()
                  loadInvoices()
                }
              "
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Все статусы</option>
              <option value="true">Черновик</option>
              <option value="false">Опубликован</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Оплата</label
            >
            <select
              v-model="filters.paid"
              @change="
                () => {
                  updateURL()
                  loadInvoices()
                }
              "
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">Все</option>
              <option value="true">Оплачен</option>
              <option value="false">Не оплачен</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Дата начала периода</label
            >
            <input
              v-model="filters.date_from"
              @blur="
                () => {
                  updateURL()
                  loadInvoices()
                }
              "
              type="date"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Дата конца периода</label
            >
            <input
              v-model="filters.date_to"
              @blur="
                () => {
                  updateURL()
                  loadInvoices()
                }
              "
              type="date"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Юридическое лицо</label
            >
            <input
              v-model="filters.legal_name"
              @input="debouncedSearch"
              type="text"
              placeholder="Введите название юр. лица..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Платежный аккаунт</label
            >
            <input
              v-model="filters.payment_account_name"
              @input="debouncedSearch"
              type="text"
              placeholder="Введите название платежного аккаунта..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >ID платежного аккаунта</label
            >
            <input
              v-model="filters.payment_account_id"
              @input="debouncedSearch"
              type="number"
              placeholder="Введите ID платежного аккаунта..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Сумма</label
            >
            <input
              v-model="filters.sum_amount"
              @input="debouncedSearch"
              type="number"
              placeholder="Введите сумму..."
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <div v-if="loading" class="flex items-center justify-center py-12">
          <div
            class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
          ></div>
          <span class="ml-3 text-gray-600">Загрузка счетов...</span>
        </div>

        <table
          v-else
          class="min-w-full divide-y divide-gray-200"
          style="min-width: 1060px"
        >
          <thead class="bg-gray-50">
            <tr>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 60px"
              >
                <input
                  type="checkbox"
                  :checked="allSelected"
                  @change="toggleAllSelection"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 100px"
              >
                Просмотр
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 200px"
              >
                Клиент
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 200px"
              >
                Юр. лицо
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 120px"
              >
                Период
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 120px"
              >
                Статус
              </th>

              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 120px"
              >
                Оплачено
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                style="min-width: 120px"
              >
                Сумма
              </th>
              <th
                class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider sticky right-0 bg-gray-50 z-10"
                style="min-width: 120px"
              >
                Действия
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr
              v-for="invoice in invoices"
              :key="invoice.id"
              :class="[
                'transition-colors duration-150',
                invoice.fake ? 'bg-orange-50 hover:bg-orange-100' : 'hover:bg-gray-50'
              ]"
            >
              <td class="px-4 py-3 whitespace-nowrap text-center">
                <input
                  type="checkbox"
                  :checked="selectedInvoices.includes(invoice.id)"
                  @change="toggleInvoiceSelection(invoice.id)"
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-center">
                <button
                  @click="viewInvoice(invoice)"
                  class="text-gray-600 hover:text-gray-900 transition-colors duration-150 relative group"
                  title="Просмотр"
                >
                  <i class="pi pi-eye"></i>
                  <div
                    class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-20"
                  >
                    Просмотр
                    <div
                      class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"
                    ></div>
                  </div>
                </button>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div
                  class="text-sm text-gray-900"
                  :title="invoice.payment_account_name"
                >
                  {{ invoice.payment_account_name }}
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div class="text-sm text-gray-900" :title="invoice.legal_name">
                  {{ invoice.legal_name }}
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                {{ formatPeriod(invoice.payment_period) }}
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <div class="flex items-center gap-2 flex-wrap">
                  <span
                    :class="{
                      'px-2 py-1 text-xs font-medium rounded-full': true,
                      'bg-yellow-100 text-yellow-800': invoice.draft,
                      'bg-green-100 text-green-800': !invoice.draft
                    }"
                  >
                    {{ invoice.draft ? 'Черновик' : 'Опубликован' }}
                  </span>
                  <span
                    v-if="invoice.fake"
                    class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800"
                  >
                    Фейковый
                  </span>
                </div>
              </td>

              <td class="px-4 py-3 whitespace-nowrap">
                <span
                  :class="{
                    'px-2 py-1 text-xs font-medium rounded-full': true,
                    'bg-green-100 text-green-800': invoice.paid,
                    'bg-red-100 text-red-800': !invoice.paid
                  }"
                >
                  {{ invoice.paid ? 'Да' : 'Нет' }}
                </span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap">
                <span class="text-sm font-medium text-gray-900">
                  {{ formatCurrency(invoice.sum_amount) }}
                </span>
              </td>
              <td
                class="px-4 py-3 whitespace-nowrap text-right text-sm font-medium sticky right-0 bg-white z-10"
              >
                <div class="flex items-center justify-end space-x-4">
                  <button
                    @click="openDocumentsModal(invoice)"
                    class="text-blue-600 hover:text-blue-900 transition-colors duration-150 relative group"
                    title="Документы"
                  >
                    <i class="pi pi-file"></i>
                    <div
                      class="absolute bottom-full right-0 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-20"
                    >
                      Документы
                      <div
                        class="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"
                      ></div>
                    </div>
                  </button>
                  <button
                    @click="openEditModal(invoice)"
                    class="text-blue-600 hover:text-blue-900 transition-colors duration-150 relative group"
                    title="Редактировать"
                  >
                    <i class="pi pi-pencil"></i>
                    <div
                      class="absolute bottom-full right-0 mb-2 px-2 py-1 text-xs text-white bg-gray-900 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-20"
                    >
                      Редактировать
                      <div
                        class="absolute top-full right-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"
                      ></div>
                    </div>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="bg-gray-50 px-6 py-3 border-t border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <span class="text-sm text-gray-500">
              Всего записей: {{ totalCount }}
            </span>
            <div class="flex items-center space-x-2">
              <span class="text-sm text-gray-500">Показать:</span>
              <select
                v-model="filters.limit"
                class="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                @change="handleLimitChange"
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
              <span class="text-sm text-gray-500">записей</span>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <button
              @click="prevPage"
              :disabled="filters.page <= 1"
              class="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
            >
              Назад
            </button>
            <span class="text-sm text-gray-500">
              Страница {{ filters.page }}
            </span>
            <button
              @click="nextPage"
              :disabled="invoices.length < filters.limit"
              class="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
            >
              Вперед
            </button>
          </div>
        </div>
      </div>
    </div>

    <InvoiceForm
      :show="showModal"
      :mode="modalMode"
      :invoice="form"
      @close="closeModal"
      @submit="handleInvoiceSubmit"
    />
  </div>

  <div
    v-if="showDocumentsModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
    @click="closeDocumentsModal"
  >
    <div
      class="relative top-20 mx-auto p-5 border w-11/12 md:w-4/5 lg:w-3/4 xl:w-2/3 shadow-lg rounded-md bg-white"
      @click.stop
    >
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium text-gray-900">
          Документы счета {{ selectedInvoice?.number_of_invoice }}
        </h3>
        <button
          @click="closeDocumentsModal"
          class="text-gray-400 hover:text-gray-600"
        >
          <i class="pi pi-times text-xl"></i>
        </button>
      </div>

      <div class="mb-6">
        <div class="flex items-center space-x-4 mb-4">
          <select
            v-model="uploadForm.document_type"
            class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Выберите тип документа</option>
            <option value="invoice">Счет</option>
            <option value="act">Акт</option>
          </select>
          <input
            ref="fileInput"
            type="file"
            @change="handleFileSelect"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
            class="hidden"
          />
          <button
            @click="$refs.fileInput.click()"
            class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            <i class="pi pi-upload mr-2"></i>
            Выбрать файл
          </button>
          <button
            v-if="uploadForm.file && uploadForm.document_type"
            @click="uploadDocument"
            :disabled="uploading"
            class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50"
          >
            <i class="pi pi-check mr-2"></i>
            {{ uploading ? 'Загрузка...' : 'Загрузить' }}
          </button>
        </div>
        <div v-if="uploadForm.file" class="text-sm text-gray-600">
          Выбран файл: {{ uploadForm.file.name }}
        </div>
      </div>

      <div v-if="documentsLoading" class="flex justify-center py-8">
        <div
          class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
        ></div>
      </div>

      <div
        v-else-if="documents.length === 0"
        class="text-center py-8 text-gray-500"
      >
        Документы не найдены
      </div>

      <div v-else class="space-y-3">
        <div
          v-for="document in documents"
          :key="document.id"
          class="flex items-center justify-between p-3 border border-gray-200 rounded-lg"
        >
          <div class="flex items-center space-x-3">
            <i class="pi pi-file text-blue-600"></i>
            <div>
              <div class="font-medium">{{ document.document_name }}</div>
              <div class="text-sm text-gray-500">
                {{ getDocumentTypeName(document.document_type) }}
              </div>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <button
              @click="downloadDocument(document.id, document.document_name)"
              class="text-blue-600 hover:text-blue-800 transition-colors"
              title="Скачать"
            >
              <i class="pi pi-download"></i>
            </button>
            <button
              @click="deleteDocument(document.id)"
              class="text-red-600 hover:text-red-800 transition-colors"
              title="Удалить"
            >
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="showDeleteConfirmModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50"
    @click="closeDeleteConfirmModal"
  >
    <div
      class="relative top-20 mx-auto p-5 border w-11/12 md:w-1/3 lg:w-1/4 shadow-lg rounded-md bg-white"
      style="min-width: 400px"
      @click.stop
    >
      <div class="flex items-center mb-4">
        <div class="flex-shrink-0">
          <i class="pi pi-exclamation-triangle text-red-500 text-2xl"></i>
        </div>
        <div class="ml-3">
          <h3 class="text-lg font-medium text-gray-900">
            Подтверждение удаления
          </h3>
        </div>
      </div>

      <div class="mb-6">
        <p class="text-sm text-gray-600">
          Вы уверены, что хотите удалить документ "{{
            documentToDelete?.document_name
          }}"?
        </p>
        <p class="text-xs text-gray-500 mt-2">Это действие нельзя отменить.</p>
      </div>

      <div class="flex justify-end space-x-3">
        <button
          @click="closeDeleteConfirmModal"
          class="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors"
        >
          Отмена
        </button>
        <button
          @click="confirmDeleteDocument"
          :disabled="deleting"
          class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50"
        >
          <i class="pi pi-trash mr-2"></i>
          {{ deleting ? 'Удаление...' : 'Удалить' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import { useToast } from 'primevue/usetoast'
  import { invoiceApi, contractApi, documentService } from '../services/api'
  import InvoiceForm from '../components/InvoiceForm.vue'
  import { getApiErrorMessage } from '../utils/apiError'

  const router = useRouter()
  const route = useRoute()
  const toast = useToast()

  const invoices = ref([])
  const contracts = ref([])
  const loading = ref(false)
  const error = ref('')
  const showModal = ref(false)
  const submitting = ref(false)
  const modalMode = ref('create')
  const contractsLoading = ref(false)
  const totalCount = ref(0)
  const showDocumentsModal = ref(false)
  const selectedInvoice = ref(null)
  const documents = ref([])
  const documentsLoading = ref(false)
  const uploading = ref(false)
  const showDeleteConfirmModal = ref(false)
  const documentToDelete = ref(null)
  const deleting = ref(false)

  const uploadForm = ref({
    document_type: '',
    file: null
  })

  const showFilters = ref(false)
  const selectedInvoices = ref([])

  const activeFiltersCount = computed(() => {
    let count = 0
    const filterFields = [
      'id',
      'contract_id',
      'number_of_contract',
      'draft',
      'paid',
      'date_of_invoice',
      'number_of_invoice',
      'legal_name',
      'payment_account_name',
      'payment_account_id',
      'sum_amount',
      'date_from',
      'date_to'
    ]

    filterFields.forEach(field => {
      const value = filters.value[field]
      if (value !== null && value !== '' && value !== undefined) {
        count++
      }
    })

    return count
  })

  const allSelected = computed(() => {
    return (
      invoices.value.length > 0 &&
      selectedInvoices.value.length === invoices.value.length
    )
  })

  const filters = ref({
    page: 1,
    limit: 100,
    sort: 'date_of_invoice',
    order: 'asc',
    id: null,
    contract_id: null,
    number_of_contract: null,
    draft: null,
    paid: null,
    date_of_invoice: null,
    number_of_invoice: null,
    legal_name: null,
    payment_account_name: null,
    payment_account_id: null,
    sum_amount: null,
    date_from: null,
    date_to: null
  })

  const form = ref({
    contract_id: '',
    date_of_invoice: '',
    number_of_invoice: '',
    payment_period: '',
    delivered: false,
    comment: '',
    draft: true,
    paid: false
  })

  const loadInvoices = async () => {
    loading.value = true
    error.value = ''
    selectedInvoices.value = []
    try {
      const params = {
        page: filters.value.page,
        limit: filters.value.limit,
        sort: filters.value.sort,
        order: filters.value.order
      }

      if (filters.value.date_from && filters.value.date_from !== '')
        params['date_from'] = filters.value.date_from
      if (filters.value.date_to && filters.value.date_to !== '')
        params['date_to'] = filters.value.date_to

      if (filters.value.id && filters.value.id !== '')
        params['filters[id]'] = filters.value.id
      if (filters.value.contract_id && filters.value.contract_id !== '')
        params['filters[contract_id]'] = filters.value.contract_id
      if (
        filters.value.number_of_contract &&
        filters.value.number_of_contract !== ''
      )
        params['filters[number_of_contract]'] = filters.value.number_of_contract
      if (filters.value.draft !== null && filters.value.draft !== '')
        params['filters[draft]'] = filters.value.draft
      if (filters.value.paid !== null && filters.value.paid !== '')
        params['filters[paid]'] = filters.value.paid
      if (filters.value.date_of_invoice && filters.value.date_of_invoice !== '')
        params['filters[date_of_invoice]'] = filters.value.date_of_invoice
      if (
        filters.value.number_of_invoice &&
        filters.value.number_of_invoice !== ''
      )
        params['filters[number_of_invoice]'] = filters.value.number_of_invoice
      if (filters.value.legal_name && filters.value.legal_name !== '')
        params['filters[legal_name]'] = filters.value.legal_name
      if (
        filters.value.payment_account_name &&
        filters.value.payment_account_name !== ''
      )
        params['filters[payment_account_name]'] =
          filters.value.payment_account_name
      if (
        filters.value.payment_account_id &&
        filters.value.payment_account_id !== ''
      )
        params['filters[payment_account_id]'] = filters.value.payment_account_id
      if (filters.value.sum_amount && filters.value.sum_amount !== '')
        params['filters[sum_amount]'] = filters.value.sum_amount

      const response = await invoiceApi.getList(params)
      if (response && response.invoices) {
        invoices.value = response.invoices
        totalCount.value = response.total_count || 0
      } else if (Array.isArray(response)) {
        invoices.value = response
        totalCount.value = response.length
      } else {
        invoices.value = []
        totalCount.value = 0
      }
    } catch (err) {
      error.value = err.message
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: err.message,
        life: 3000
      })
    } finally {
      loading.value = false
    }
  }

  const loadContracts = async () => {
    contractsLoading.value = true
    try {
      const response = await contractApi.getList()
      if (response && Array.isArray(response)) {
        contracts.value = response
      } else if (
        response &&
        response.contracts &&
        Array.isArray(response.contracts)
      ) {
        contracts.value = response.contracts
      } else if (response && response.data && Array.isArray(response.data)) {
        contracts.value = response.data
      } else {
        contracts.value = []
      }
    } catch (err) {
      console.error('Error loading contracts:', err)
      contracts.value = []
    } finally {
      contractsLoading.value = false
    }
  }

  const openCreateModal = () => {
    modalMode.value = 'create'
    resetForm()
    showModal.value = true
  }

  const openEditModal = invoice => {
    modalMode.value = 'edit'
    form.value = {
      ...invoice,
      payment_period: invoice.payment_period
        ? invoice.payment_period.substring(0, 7)
        : ''
    }
    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
    resetForm()
  }

  const resetForm = () => {
    form.value = {
      contract_id: '',
      date_of_invoice: '',
      number_of_invoice: '',
      payment_period: '',
      delivered: false,
      comment: '',
      draft: true,
      paid: false,
      full_payment: false
    }
  }

  const handleInvoiceSubmit = async formData => {
    submitting.value = true
    try {
      if (modalMode.value === 'create') {
        await invoiceApi.create(formData)
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Счет создан',
          life: 3000
        })
      } else {
        const updateData = {
          draft: formData.draft,
          paid: formData.paid,
          date_of_invoice: formData.date_of_invoice,
          number_of_invoice: formData.number_of_invoice,
          payment_period: formData.payment_period,
          delivered: formData.delivered,
          comment: formData.comment,
          full_payment: formData.full_payment,
          fake: formData.fake
        }
        await invoiceApi.update(form.value.id, updateData)
        toast.add({
          severity: 'success',
          summary: 'Успешно',
          detail: 'Счет обновлен',
          life: 3000
        })
      }
      closeModal()
      loadInvoices()
    } catch (err) {
      console.error('Submit error:', err)
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: getApiErrorMessage(err, 'Произошла ошибка при сохранении'),
        life: 5000
      })
    } finally {
      submitting.value = false
    }
  }

  const viewInvoice = invoice => {
    router.replace(`/invoices/${invoice.id}`)
  }

  const toggleInvoiceSelection = invoiceId => {
    const index = selectedInvoices.value.indexOf(invoiceId)
    if (index > -1) {
      selectedInvoices.value.splice(index, 1)
    } else {
      selectedInvoices.value.push(invoiceId)
    }
  }

  const toggleAllSelection = () => {
    if (allSelected.value) {
      selectedInvoices.value = []
    } else {
      selectedInvoices.value = invoices.value.map(invoice => invoice.id)
    }
  }

  const copySelectedInvoices = async () => {
    if (selectedInvoices.value.length === 0) return

    try {
      await invoiceApi.copy(selectedInvoices.value)
      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail: `Счета успешно скопированы`,
        life: 3000
      })
      selectedInvoices.value = []
      await loadInvoices()
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: err.message,
        life: 3000
      })
    }
  }

  const formatDate = date => {
    if (!date) return ''

    let dateString = date

    if (typeof date === 'object' && date.date) {
      dateString = date.date
    }

    try {
      return new Date(dateString).toLocaleDateString('ru-RU')
    } catch (error) {
      return 'Неверная дата'
    }
  }

  const formatPeriod = date => {
    if (!date) return ''
    try {
      const dateObj = new Date(date)
      return dateObj.toLocaleDateString('ru-RU', {
        month: 'long',
        year: 'numeric'
      })
    } catch (error) {
      return 'Неверная дата'
    }
  }

  const formatCurrency = amount => {
    if (!amount && amount !== 0) return '0'

    try {
      return new Intl.NumberFormat('ru-RU', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)
    } catch (error) {
      return `${amount}`
    }
  }

  const debouncedSearch = () => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      filters.value.page = 1
      updateURL()
      loadInvoices()
    }, 500)
  }

  const resetFilters = () => {
    filters.value = {
      page: 1,
      limit: 100,
      sort: 'date_of_invoice',
      order: 'asc',
      id: null,
      contract_id: null,
      number_of_contract: null,
      draft: null,
      paid: null,
      date_of_invoice: null,
      number_of_invoice: null,
      legal_name: null,
      payment_account_name: null,
      payment_account_id: null,
      sum_amount: null,
      date_from: null,
      date_to: null
    }
    updateURL()
    loadInvoices()
  }

  const updateURL = () => {
    const query = {}

    if (filters.value.page > 1) query.page = filters.value.page
    query.limit = filters.value.limit
    query.sort = filters.value.sort
    query.order = filters.value.order

    if (filters.value.date_from && filters.value.date_from !== '')
      query['date_from'] = filters.value.date_from
    if (filters.value.date_to && filters.value.date_to !== '')
      query['date_to'] = filters.value.date_to

    if (filters.value.id && filters.value.id !== '')
      query['filters[id]'] = filters.value.id
    if (filters.value.contract_id && filters.value.contract_id !== '')
      query['filters[contract_id]'] = filters.value.contract_id
    if (
      filters.value.number_of_contract &&
      filters.value.number_of_contract !== ''
    )
      query['filters[number_of_contract]'] = filters.value.number_of_contract
    if (filters.value.draft !== null && filters.value.draft !== '')
      query['filters[draft]'] = filters.value.draft
    if (filters.value.paid !== null && filters.value.paid !== '')
      query['filters[paid]'] = filters.value.paid
    if (filters.value.date_of_invoice && filters.value.date_of_invoice !== '')
      query['filters[date_of_invoice]'] = filters.value.date_of_invoice
    if (
      filters.value.number_of_invoice &&
      filters.value.number_of_invoice !== ''
    )
      query['filters[number_of_invoice]'] = filters.value.number_of_invoice
    if (filters.value.legal_name && filters.value.legal_name !== '')
      query['filters[legal_name]'] = filters.value.legal_name
    if (
      filters.value.payment_account_name &&
      filters.value.payment_account_name !== ''
    )
      query['filters[payment_account_name]'] =
        filters.value.payment_account_name
    if (
      filters.value.payment_account_id &&
      filters.value.payment_account_id !== ''
    )
      query['filters[payment_account_id]'] = filters.value.payment_account_id
    if (filters.value.sum_amount && filters.value.sum_amount !== '')
      query['filters[sum_amount]'] = filters.value.sum_amount

    router.replace({ query })
  }

  const loadFiltersFromURL = () => {
    const query = route.query

    if (query.page) filters.value.page = parseInt(query.page)
    if (query.limit) filters.value.limit = parseInt(query.limit)
    if (query.sort) filters.value.sort = query.sort
    if (query.order) filters.value.order = query.order

    if (query['date_from']) filters.value.date_from = query['date_from']
    if (query['date_to']) filters.value.date_to = query['date_to']

    if (query['filters[id]']) filters.value.id = query['filters[id]']
    if (query['filters[contract_id]'])
      filters.value.contract_id = query['filters[contract_id]']
    if (query['filters[number_of_contract]'])
      filters.value.number_of_contract = query['filters[number_of_contract]']
    if (query['filters[draft]'] !== undefined)
      filters.value.draft = query['filters[draft]'] === 'true'
    if (query['filters[paid]'] !== undefined)
      filters.value.paid = query['filters[paid]'] === 'true'
    if (query['filters[date_of_invoice]'])
      filters.value.date_of_invoice = query['filters[date_of_invoice]']
    if (query['filters[number_of_invoice]'])
      filters.value.number_of_invoice = query['filters[number_of_invoice]']
    if (query['filters[legal_name]'])
      filters.value.legal_name = query['filters[legal_name]']
    if (query['filters[payment_account_name]'])
      filters.value.payment_account_name =
        query['filters[payment_account_name]']
    if (query['filters[payment_account_id]'])
      filters.value.payment_account_id = query['filters[payment_account_id]']
    if (query['filters[sum_amount]'])
      filters.value.sum_amount = query['filters[sum_amount]']
  }

  let searchTimeout

  const prevPage = () => {
    if (filters.value.page > 1) {
      filters.value.page--
      updateURL()
      loadInvoices()
    }
  }

  const nextPage = () => {
    if (invoices.value.length === filters.value.limit) {
      filters.value.page++
      updateURL()
      loadInvoices()
    }
  }

  const handleLimitChange = () => {
    filters.value.page = 1
    updateURL()
    loadInvoices()
  }

  const openDocumentsModal = async invoice => {
    selectedInvoice.value = invoice
    showDocumentsModal.value = true
    await loadDocuments(invoice.id)
  }

  const closeDocumentsModal = () => {
    showDocumentsModal.value = false
    selectedInvoice.value = null
    documents.value = []
    uploadForm.value = { document_type: '', file: null }
  }

  const loadDocuments = async invoiceId => {
    documentsLoading.value = true
    try {
      const response = await documentService.getInvoiceDocuments(invoiceId)
      documents.value = response.documents || []
    } catch (err) {
      documents.value = []
    } finally {
      documentsLoading.value = false
    }
  }

  const getDocumentTypeName = documentType => {
    const types = {
      invoice: 'Счет',
      act: 'Акт'
    }
    return types[documentType] || documentType
  }

  const handleFileSelect = event => {
    const file = event.target.files[0]
    if (file) {
      uploadForm.value.file = file
    }
  }

  const uploadDocument = async () => {
    if (!uploadForm.value.file || !uploadForm.value.document_type) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Выберите файл и тип документа',
        life: 3000
      })
      return
    }

    uploading.value = true
    try {
      await documentService.uploadDocument(
        selectedInvoice.value.id,
        uploadForm.value.document_type,
        uploadForm.value.file
      )

      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail: 'Документ загружен',
        life: 3000
      })

      uploadForm.value = { document_type: '', file: null }
      await loadDocuments(selectedInvoice.value.id)
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: err.message,
        life: 3000
      })
    } finally {
      uploading.value = false
    }
  }

  const downloadDocument = async (documentId, documentName) => {
    try {
      const response = await documentService.downloadDocument(documentId)

      if (!response.data || response.data.size === 0) {
        throw new Error('Получен пустой файл')
      }

      const contentType = response.headers['content-type']

      if (contentType && contentType.includes('application/pdf')) {
        const url = window.URL.createObjectURL(response.data)

        window.open(url, '_blank')

        setTimeout(() => {
          window.URL.revokeObjectURL(url)
        }, 5000)
      } else {
        const url = window.URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', documentName)
        link.style.display = 'none'

        document.body.appendChild(link)
        link.click()

        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
      }

      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail:
          contentType && contentType.includes('application/pdf')
            ? 'PDF документ открыт в новой вкладке'
            : 'Документ скачан',
        life: 3000
      })
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Ошибка при скачивании документа',
        life: 5000
      })
    }
  }

  const deleteDocument = documentId => {
    const document = documents.value.find(doc => doc.id === documentId)
    documentToDelete.value = document
    showDeleteConfirmModal.value = true
  }

  const closeDeleteConfirmModal = () => {
    showDeleteConfirmModal.value = false
    documentToDelete.value = null
  }

  const confirmDeleteDocument = async () => {
    if (!documentToDelete.value) return

    deleting.value = true
    try {
      await documentService.deleteDocument(documentToDelete.value.id)
      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail: 'Документ удален',
        life: 3000
      })
      await loadDocuments(selectedInvoice.value.id)
      closeDeleteConfirmModal()
    } catch (err) {
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: err.message,
        life: 3000
      })
    } finally {
      deleting.value = false
    }
  }

  watch([() => filters.value.sort, () => filters.value.order], () => {
    updateURL()
  })

  onMounted(() => {
    loadFiltersFromURL()
    loadInvoices()
    loadContracts()
  })
</script>

<style scoped>
  .overflow-x-auto {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .overflow-x-auto::-webkit-scrollbar {
    height: 8px;
  }

  .overflow-x-auto::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  .overflow-x-auto::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  .overflow-x-auto::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  table {
    width: 100%;
  }

  th,
  td {
    white-space: nowrap;
    padding: 12px 8px;
    min-width: 120px;
  }

  th:nth-child(6),
  td:nth-child(6) {
    min-width: 100px;
  }

  th:first-child,
  td:first-child {
    min-width: 80px;
  }

  th:last-child,
  td:last-child {
    min-width: 100px;
    position: sticky;
    right: 0;
    background-color: white;
    z-index: 10;
  }

  th:last-child {
    background-color: #f9fafb;
  }

  tr:hover td:last-child {
    background-color: #f3f4f6;
  }
</style>
